import classNames from 'classnames';
import { NavLinkProps, useLocation, matchPath } from 'react-router-dom';
import { LocationDescriptorObject } from 'history';
import { isString } from 'utils/common';
import { useIsMobile } from 'utils/hooks';
import LinkOrPorted from 'components/atoms/LinkOrPorted';

interface UserMenuLinkProps extends NavLinkProps {
  title?: string;
  to: string | LocationDescriptorObject;
  matchingRoutes?: string[];
  dataDurableId?: string;
  italic?: boolean;
}

function UserMenuLink({ title, to, matchingRoutes = [], dataDurableId, italic, ...rest }: UserMenuLinkProps) {
  const location = useLocation();
  const isActive =
    isString(to) &&
    !!matchPath(location.pathname, {
      path: matchingRoutes.length > 0 ? [to].concat(matchingRoutes) : to,
      exact: true,
    });
  const isMobile = useIsMobile();

  return (
    <LinkOrPorted
      {...rest}
      type="navlink"
      dataDurableId={dataDurableId}
      isActive={() => isActive}
      to={to}
      className={classNames('cursor-pointer text-sm font-normal focus:outline-none md:hover:text-charcoal-50', {
        italic,
        'text-charcoal-50': isActive && !isMobile,
        'text-charcoal-900': isActive && isMobile,
        'text-charcoal-400': !isActive,
      })}
    >
      <div className="py-2">{title}</div>
    </LinkOrPorted>
  );
}

export default UserMenuLink;
